import { render, staticRenderFns } from "./productstorestatistical-list.vue?vue&type=template&id=1253b2be&scoped=true&"
import script from "./productstorestatistical-list.vue?vue&type=script&lang=ts&"
export * from "./productstorestatistical-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1253b2be",
  null
  
)

export default component.exports